export function initials(name) {
  return (
    (name || "")
      .split(" ")
      .filter(Boolean)
      .map((w) => w[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || "?"
  );
}

// Shared style for the list-view column-header row. Title Case labels in a subdued
// dark gray, matching the V2 Source Directory Figma (no uppercase / letter-spacing).
// Padding and gap must match the list rows' own, or headers drift out of their columns.
export const listHeaderRowStyle = {
  fontSize: 12,
  fontWeight: 600,
  color: "#4d5357",
  display: "flex",
  gap: 16,
  padding: "0 16px 8px",
};
